import React, { forwardRef } from 'react';
import type { ReactNode } from 'react';
import { Text } from '@balance-web/text';

export type BreadCrumbTextItemProps = {
  children: ReactNode;
};

export const BreadCrumbTextItem = forwardRef<
  HTMLDivElement,
  BreadCrumbTextItemProps
>((props, ref) => {
  return (
    <Text ref={ref} size="xsmall" weight="medium">
      {props.children}
    </Text>
  );
});
